import {Plain} from '../../../../shared/model/plain.type.model';
import {ElementPage} from './elements/element.page.model';
import {toElementPage} from './elements/to-element-page.model';

export class PageConclusion {
    public title: Record<string, string>;
    public description: Record<string, string>;
    public elements: ElementPage[];

    constructor(data: Plain<PageConclusion>) {
        // L'API omet les champs non renseignés : on normalise en structures vides, jamais en null.
        this.title = data.title ?? {};
        this.description = data.description ?? {};
        this.elements = (data.elements ?? []).map(toElementPage);
    }
}
